// import { AppEnvironment } from './env.model';
import { Injectable } from '@angular/core';
import { isCardApi, localBackend } from '../config/app-config';

@Injectable({
  providedIn: 'root',
})
// export class EnvService implements AppEnvironment {
export class EnvService {
  // The values that are defined here are the default values that can
  // be overridden by env.js
  private env!: string;
  private _host = 'stellar.moneygram.com'; // TODO: Tim: revert #mar11
  // private _host = 'localhost:3000'; // TODO: Tim: revert
  private _applicationContext = 'stellaradapterservice';
  private _protocol = localBackend ? 'http' : 'https'; // TODO: Tim: revert #mar11
  // private _protocol = localBackend ? 'http' : 'http'; // TODO: Tim: revert
  private _clientKey = '';
  private _apiUrl = `${this._protocol}://${this.getEnv()}${this._host}/${
    this._applicationContext
  }`;
  private _cmsUrl =
    this.getCmsEnv() !== 'prod'
      ? `https://webv2cms${this.getCmsEnv()}.aws.moneygram.com/WEB/MGO`
      : `https://webv2cms${this.getCmsEnv()}.aws.moneygram.com/WEB/release25.01/MGO`;
  private _product = 'MGO';
  private _gmapKey = 'AIzaSyB26p9XG13v5lK64Z_D-1A96j70HwbV05M';
  private _xapikey = '';

  private _locale = 'en_US';
  private _country = 'US';
  private _searchRadius = 5;
  private _searchLimit = 10;
  private _radiusuom = 'mile';
  private _language = 'EN';

  set locale(l: string) {
    this._locale = l;
    const splits = l.split('_'); // en_US  (or) en_US_WALMART
  }
  get locale() {
    return this._locale;
  }

  public get cmsUrl() {
    return this._cmsUrl;
  }

  public get product() {
    return this._product;
  }

  public get country() {
    return this._country;
  }
  public set country(value) {
    this._country = value;
  }
  public get language() {
    return this._language;
  }
  public set language(value) {
    this._language = value;
  }
  public get clientKey() {
    return this._clientKey;
  }
  public set clientKey(value) {
    this._clientKey = value;
  }

  public get apiUrl() {
    return this._apiUrl;
  }
  public set apiUrl(value) {
    this._apiUrl = value;
  }

  public get gmapKey() {
    return this._gmapKey;
  }
  public set gmapKey(value) {
    this._gmapKey = value;
  }

  public get xapikey() {
    return this._xapikey;
  }
  public set xapikey(value) {
    this._xapikey = value;
  }

  public get searchRadius() {
    return this._searchRadius;
  }
  public set searchRadius(value) {
    this._searchRadius = value;
  }

  public get searchLimit() {
    return this._searchLimit;
  }
  public set searchLimit(value) {
    this._searchLimit = value;
  }

  public get radiusuom() {
    return this._radiusuom;
  }
  public set radiusuom(value) {
    this._radiusuom = value;
  }

  // Whether or not to enable debug mode
  public enableDebug = true;

  public getEnv() {
    const host = window.location.host;
    if (host.includes('localhost')) {
      if (localBackend) {
        this.env = 'localhost:9800';
        this._host = '';
      } else {
        this.env = 'd5'; // TODO: Tim: revert #mar11
        // this.env = ''; // TODO: Tim: revert
      }
    } else {
      if (
        host.indexOf('d5stellar') > -1 ||
        host.indexOf('d5sdfuicard') > -1 ||
        host.indexOf('d5mgxanchor') > -1
      ) {
        this.env = 'd5';
      } else if (
        host.indexOf('q5stellar') > -1 ||
        host.indexOf('q5sdfuicard') > -1 ||
        host.indexOf('q5mgxanchor') > -1
      ) {
        this.env = 'q5';
      } else if (
        host.indexOf('d3stellar') > -1 ||
        host.indexOf('d3sdfuicard') > -1 ||
        host.indexOf('d3mgxanchor') > -1
      ) {
        this.env = 'd3';
      } else if (
        host.indexOf('q3stellar') > -1 ||
        host.indexOf('q3sdfuicard') > -1 ||
        host.indexOf('q3mgxanchor') > -1
      ) {
        this.env = 'q3';
      } else if (
        host.indexOf('q2stellar') > -1 ||
        host.indexOf('q2sdfuicard') > -1 ||
        host.indexOf('q2mgxanchor') > -1
      ) {
        this.env = 'q2';
      } else if (
        host.indexOf('q1stellar') > -1 ||
        host.indexOf('q1sdfuicard') > -1 ||
        host.indexOf('q1mgxanchor') > -1
      ) {
        this.env = 'q1';
      } else if (
        host.indexOf('extstellar') > -1 ||
        host.indexOf('extsdfuicard') > -1 ||
        host.indexOf('extmgxanchor') > -1
      ) {
        this.env = 'ext';
      } else {
        this.env = '';
      }
    }
    return this.env;
  }

  public getCmsEnv() {
    const host = window.location.host; // Todo: Tim: Remove: revert
    if (this.getEnv() === 'ext') {
      return 'external';
    // } else if (this.getEnv() === '') { // Todo: Tim: Remove: revert
    } else if (this.getEnv() === '' && !host.includes('localhost')) { // Todo: Tim: Remove: revert
      return 'prod';
    }
    // Note: Env for lower environment changes for each CMS release
    // release24.08 is in d5 CMS
    return 'd5';
  }
}
